var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-popover',{attrs:{"placement":"top","trigger":"manual","autoHide":false,"open":_vm.isShowing,"offset":"15"}},[_vm._t("component"),_vm._v(" "),_c('template',{slot:"popover"},[_c('transition',{attrs:{"name":"fade","type":"transition"},on:{"after-enter":_vm.addTooltipListener}},[(_vm.isShowing)?_c(_vm.tooltipComponent,{tag:"component",on:{"closed":_vm.hideTooltip}}):_vm._e()],1)],1)],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5065f194","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tutorial/TutorialInterfaceItem.vue
// module id = null
// module chunks = 